// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"3b3b064c","531":"12f8444b","609":"df435aab","893":"fe9ff200"}[chunkId] + ".chunk.css";
};